import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "sub-controller-title d-flex" };
const _hoisted_2 = { class: "ml-2 d-flex align-center" };
const _hoisted_3 = {
    key: 0,
    class: "d-flex align-self-start"
};
const _hoisted_4 = { class: "body1-text" };
const _hoisted_5 = { class: "filter-section" };
const _hoisted_6 = { class: "brg-input-section month-picker-activator-with-icon" };
const _hoisted_7 = { class: "brg-color-grey-600 text-subtitle-2" };
const _hoisted_8 = {
    key: 0,
    class: "search"
};
import { computed, onBeforeUnmount, onMounted, ref, } from 'vue';
import { format, parse, } from 'date-fns';
import { afterMonths, beforeDays, } from '@/utils/time';
import SubControllerTemplate from '@/templates/SubControllerTemplate.vue';
import Chip from '@/components/Common/Chip.vue';
import { reportTypeOptionMapper } from '@/types/entity/IHubAdjustmentDaily';
import { useRoute, useRouter, } from 'vue-router';
import { i18n } from '@/locales';
import dateFormatType from '@/constants/dateFormatType';
import SearchInput from '@/components/Form/SearchInput.vue';
import vuexStore from '@/vuex-store';
const lc = 'views.hub_adjustment_daily.';
// 검색어
const path = 'views.hub_adjustment_daily.page_title.sales';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubController',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const searchKeyword = ref('');
        const setSearchKeyword = (value) => {
            searchKeyword.value = value;
            vuexStore.dispatch('hubAdjustment/hubDailyReport/setKeyword', value);
        };
        // 현재 정산 타입
        const currentReportType = computed({
            get() { return vuexStore.state.hubAdjustment.hubDailyReport.reportType; },
            set() { },
        });
        const isSearchFieldExist = computed({
            get() {
                const type = currentReportType.value;
                const isExist = type === reportTypeOptionMapper.STORE_MANAGEMENT_FEE
                    || type === reportTypeOptionMapper.SALES_ORDER_DISTRIBUTOR_HUB_FEE;
                return isExist;
            },
            set() { },
        });
        const isInformationFieldExist = computed({
            get() {
                const type = currentReportType.value;
                const isExist = type === reportTypeOptionMapper.STORE_MANAGEMENT_FEE;
                return isExist;
            },
            set() { },
        });
        // 현재 서브 타이틀
        const title = computed({
            get() {
                return i18n.t(path, {
                    type: vuexStore.getters['hubAdjustment/hubDailyReport/getterSelectedTypeName'],
                });
            },
            set() { },
        });
        const getterSelectedChipInfo = computed({
            get() { return vuexStore.getters['hubAdjustment/hubDailyReport/getterSelectedChipInfo']; },
            set() { },
        });
        // 메인 페이지에서 선택 된 달
        const selectedMonth = ref('');
        const setSelectedMonthFromPath = () => {
            const { params } = route;
            selectedMonth.value = params.selectedMonth;
        };
        // 달력 내 선택 가능한 가장 빠른 날 (및 기본 시작일)
        const minDate = ref('');
        const getDefaultSelectedPeriodMinDate = () => {
            const dateFormat = dateFormatType.DATE;
            const min = parse(selectedMonth.value, 'yyyy-MM', new Date());
            return format(min, dateFormat);
        };
        // 달력 내 선택 가능한 가장 늦은 날 (및 기본 종료일)
        const maxDate = ref('');
        const getDefaultSelectedPeriodMaxDate = () => {
            const dateFormat = dateFormatType.DATE;
            const parsedDate = parse(selectedMonth.value, 'yyyy-MM', new Date());
            const max = beforeDays(afterMonths(parsedDate, 1), 1);
            return format(max, dateFormat);
        };
        // 달력 dialog open
        const datePickerDialog = ref(false);
        const closeDialog = () => {
            datePickerDialog.value = false;
        };
        // 선택 중인 기간
        const period = ref([]);
        const checkPeriodFormat = () => {
            // 0. 2개의 값(기간)을 선택해야 함.
            if (!period.value[1]) {
                period.value = period.value.concat(period.value[0]);
                return;
            }
            const firstDate = new Date(period.value[0]);
            const secondDate = new Date(period.value[1]);
            // fromAt이 toAt 보다 항상 더 커야 함. 자동 치환
            if (firstDate > secondDate) {
                period.value = period.value.reverse();
            }
        };
        // 선택 된 기간 (선택 중 취소시 초기화 오리진)
        const selectedPeriod = ref([]);
        const resetToSelectedPeriod = () => {
            period.value = selectedPeriod.value;
        };
        const setSelectedPeriod = async (customPeriod) => {
            selectedPeriod.value = customPeriod ?? period.value;
            const [fromAt, toAt,] = selectedPeriod.value;
            // @ts-ignore
            await vuexStore.dispatch('hubAdjustment/hubDailyReport/setFilterOption', {
                fromAt,
                toAt,
            });
            router.replace({
                query: {
                    fromAt,
                    toAt,
                },
            }).catch(() => { });
        };
        // 선택 된 기간 view
        const formattedSelectedPeriod = computed({
            get() { return selectedPeriod.value.join(' ~ '); },
            set() { },
        });
        const initPage = (isReset = false) => {
            // selectedMonth 정의
            setSelectedMonthFromPath();
            // 선택가능 범위 계산
            minDate.value = getDefaultSelectedPeriodMinDate();
            maxDate.value = getDefaultSelectedPeriodMaxDate();
            // 새로고침 대비 쿼리 서칭
            const { query } = route;
            const { fromAt, toAt } = query;
            if (isReset) {
                setSelectedPeriod([
                    minDate.value,
                    maxDate.value,
                ]);
                setSearchKeyword('');
                resetToSelectedPeriod();
                return;
            }
            // 현재 선택값 적용
            setSelectedPeriod([
                fromAt ?? minDate.value,
                toAt ?? maxDate.value,
            ]);
            resetToSelectedPeriod();
        };
        // const handleClickPickerCancel = () => {
        //   resetToSelectedPeriod();
        //   closeDialog();
        // };
        const handleClickPickerSubmit = () => {
            checkPeriodFormat();
            setSelectedPeriod();
            closeDialog();
        };
        /**
             * 검색 핸들러
             */
        const handleSearch = (value) => {
            setSearchKeyword(value);
        };
        const handleClickResetButton = () => {
            initPage(true);
        };
        onMounted(() => {
            initPage();
        });
        onBeforeUnmount(() => {
            setSearchKeyword('');
        });
        const locales = {
            selectPeriod: i18n.t(`${lc}selected_period`),
            searchInputPlaceholder: i18n.t('common.input_field_placeholder', {
                field: i18n.t('common.store_name'),
            }),
            reset: i18n.t('common.reset'),
            information: i18n.t(`${lc}report_value_is_for_reference_only_information`),
        };
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_vue_datepicker_action_row = _resolveComponent("vue-datepicker-action-row");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_vue_datepicker = _resolveComponent("vue-datepicker");
            const _component_v_btn = _resolveComponent("v-btn");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createBlock(SubControllerTemplate, null, {
                titleSlot: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("span", null, _toDisplayString(title.value), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_2, [
                            (getterSelectedChipInfo.value)
                                ? (_openBlock(), _createBlock(Chip, {
                                    key: 0,
                                    text: getterSelectedChipInfo.value.text,
                                    "brg-chip-color": getterSelectedChipInfo.value.color
                                }, null, 8 /* PROPS */, ["text", "brg-chip-color"]))
                                : _createCommentVNode("v-if", true)
                        ])
                    ]),
                    (isInformationFieldExist.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(_component_v_icon, {
                                icon: "mdi-information-outline",
                                class: "pr-1",
                                size: "24",
                                dense: ""
                            }),
                            _createElementVNode("span", _hoisted_4, _toDisplayString(locales.information), 1 /* TEXT */)
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                toolsSlot: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_vue_datepicker, {
                            modelValue: period.value,
                            "onUpdate:modelValue": [
                                _cache[0] || (_cache[0] = ($event) => ((period).value = $event)),
                                handleClickPickerSubmit
                            ],
                            range: "",
                            position: "left",
                            "model-type": "yyyy-MM-dd",
                            format: "yyyy-MM-dd",
                            "min-date": minDate.value,
                            "max-date": maxDate.value,
                            style: { "width": "230px" }
                        }, {
                            "action-row": _withCtx((props) => [
                                _createVNode(_component_vue_datepicker_action_row, _normalizeProps(_guardReactiveProps(props)), null, 16 /* FULL_PROPS */)
                            ]),
                            "dp-input": _withCtx(() => [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('common.select_period')), 1 /* TEXT */),
                                    _createVNode(_component_v_text_field, {
                                        value: formattedSelectedPeriod.value,
                                        variant: "outlined",
                                        density: "compact",
                                        readonly: "",
                                        "hide-details": "",
                                        class: "mt-2",
                                        "bg-color": "white",
                                        "prepend-inner-icon": "mdi-calendar-month-outline"
                                    }, null, 8 /* PROPS */, ["value"])
                                ])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue", "min-date", "max-date"]),
                        _createCommentVNode(" 검색어 입력 "),
                        (isSearchFieldExist.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createVNode(SearchInput, {
                                    class: "search-text-field",
                                    outlined: "",
                                    placeholder: locales.searchInputPlaceholder,
                                    "on-search": handleSearch,
                                    "default-value": searchKeyword.value
                                }, null, 8 /* PROPS */, ["placeholder", "default-value"])
                            ]))
                            : _createCommentVNode("v-if", true),
                        _createCommentVNode(" 초기화 버튼 "),
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                            class: "ml-2",
                            onClick: handleClickResetButton
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "16" }, {
                                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                                        _createTextVNode(" mdi-restart ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [1]
                                }),
                                _createElementVNode("span", null, _toDisplayString(locales.reset), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })), [
                            [
                                _directive_btn_style,
                                void 0,
                                "config",
                                {
                                    info: true,
                                    "size-l": true,
                                    outlined: true
                                }
                            ]
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
